module.exports = __webpack_public_path__ + "img/ios_en.44fac42d.png";